interface Props {
  color?: string;
  className?: string;
}

export default function MenuChatsSvg(props: Props) {
  return (
    <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.5 20.6076H19.7759C20.1257 20.6076 20.3674 20.2576 20.2434 19.9304L19.7459 18.6172C19.4845 17.9272 19.6275 17.1516 20.0491 16.5461C20.6826 15.6363 21.5 14.225 21.5 12.9999M18.5 10.5C18.5 14.6421 15.1421 18 11 18H4.22413C3.8743 18 3.63262 17.65 3.75656 17.3228L4.39762 15.6309C4.62684 15.0259 4.53271 14.355 4.25001 13.7731C3.76951 12.784 3.5 11.6735 3.5 10.5C3.5 6.35786 6.85786 3 11 3C15.1421 3 18.5 6.35786 18.5 10.5Z'
        stroke={props.color || '#737389'}
        strokeWidth='2'
        stroke-linecap='round'
      />
    </svg>
  );
}
